import React, { useState, useRef } from 'react';
import avatar from '../../uploads/avatar.png';
import { CustomCropper } from '../../services/CustomCropper';
import { Select, Upload, message, Tooltip, AutoComplete, Button, Slider } from 'antd';
import { CloudUploadOutlined, CloseOutlined, EditOutlined, RotateRightOutlined, RotateLeftOutlined, VerticalAlignMiddleOutlined, UserAddOutlined } from '@ant-design/icons';
import { AddressSuggestions } from 'react-dadata';
import 'react-dadata/dist/react-dadata.css';
import { DADATA_API_token } from '../../utils/api';
import 'react-advanced-cropper/dist/style.css';
const { PhoneNumberUtil, PhoneNumberFormat } = require('google-libphonenumber');
const { Dragger } = Upload;

const PersonalInfo = ({ formData, setFormData, selectors, changedData, setChangedData, handleCancelButtonClick, handleSaveButtonClick, loading, registrationAddress, residentialAddress, setRegistrationAddress, setResidentialAddress }) => {
  const [regRegionRef, regCityRef, regStreetRef, resRegionRef, resCityRef, resStreetRef,] = [useRef(null), useRef(null), useRef(null), useRef(null), useRef(null), useRef(null)];
  const [showRegistrationAddressModal, setShowRegistrationAddressModal] = useState(false);
  const [showResidentialAddressModal, setShowResidentialAddressModal] = useState(false);
  const [showPassportModal, setShowPassportModal] = useState(false);
  const [showWorkPhoneNumberModal, setShowWorkPhoneNumberModal] = useState(false);
  const [showBirthPlaceModal, setShowBirthPlaceModal] = useState(false);
  const [workPhone, setWorkPhone] = useState('');
  const [filesCount, setFilesCount] = useState(0);
  const [regAddressRegion, setRegAddressRegion] = useState({
    value: "",
    fias_id: "",
    iso_code: ""
  });
  const [regAddressArea, setRegAddressArea] = useState({
    value: "",
    fias_id: ""
  });
  const [regAddressCity, setRegAddressCity] = useState({
    value: "",
    city_fias_id: "",
    settlement_fias_id: ""
  });
  const [regAddressStreet, setRegAddressStreet] = useState('');
  const [regAddressHouse, setRegAddressHouse] = useState('');
  const [regAddressFlat, setRegAddressFlat] = useState('');
  const [resAddressRegion, setResAddressRegion] = useState({
    value: "",
    fias_id: "",
    iso_code: ""
  });
  const [resAddressArea, setResAddressArea] = useState({
    value: "",
    fias_id: ""
  });
  const [resAddressCity, setResAddressCity] = useState({
    value: "",
    city_fias_id: "",
    settlement_fias_id: ""
  });
  const [resAddressStreet, setResAddressStreet] = useState('');
  const [resAddressHouse, setResAddressHouse] = useState('');
  const [resAddressFlat, setResAddressFlat] = useState('');
  const [showPhotoCropperModal, setShowPhotoCropperModal] = useState(false);
  const imageUrl = formData.Photo ? `data:image/jpeg;base64, ${formData.Photo}` : avatar;
  const cropperRef = useRef(null);
  const [image, setImage] = useState(null);
  const [scale, setScale] = useState(1);
  let birthPlace = `${formData.BirthPlace.Country.Name ? formData.BirthPlace.Country.Name : ''}${formData.BirthPlace.City ? `, ${formData.BirthPlace.City}` : ''}`;
  // registrationAddress.ViewAddresses = `${registrationAddress.Country.Name}${regAddressRegion.value ? ', '+regAddressRegion.value : ''}${regAddressArea.value ? ', '+regAddressArea.value : ''}${regAddressCity.value ? ', '+regAddressCity.value : ''}${regAddressStreet ? ', '+regAddressStreet : ''}${regAddressHouse ? ', д. '+regAddressHouse : ''}${regAddressFlat ? ', кв. '+regAddressFlat : ''}`;
  // residentialAddress.ViewAddresses = `${residentialAddress.Country.Name}${resAddressRegion.value ? ', '+resAddressRegion.value : ''}${resAddressArea.value ? ', '+resAddressArea.value : ''}${resAddressCity.value ? ', '+resAddressCity.value : ''}${resAddressStreet ? ', '+resAddressStreet : ''}${resAddressHouse ? ', д. '+resAddressHouse : ''}${resAddressFlat ? ', кв. '+resAddressFlat : ''}`;

  const handleBeforeUpload = (file) => {
    const fileExtensions = [
      "DOC", "DOCX", "XLS", "XLSX", "XLSM", "PPT", "PPTX", "PDF", "TXT", "JPG", "JPEG", "BMP", "PNG"
    ];  
    const parsedName = file.name.split('.');
    const index = parsedName.length - 1;
    const extension = parsedName[index];
    if (!fileExtensions.includes(extension.toUpperCase())) {
      message.warning(`Файл с расширением .${extension} запрещён для загрузки!`);                
      return Upload.LIST_IGNORE;
    }
    if(filesCount === 10) {
      message.warning('Достигнуто максимально допустимое количество файлов 10!');
      return Upload.LIST_IGNORE;
    }
    if(file.size / 1024 > 10240) {
      message.warning('Размер файла не должен превышать 10 Мб!');                
      return Upload.LIST_IGNORE;
    } 
    return false;
  };
  
  const handleUpload = async (files) => {
    let formattedFiles = [];
    
    for (const file of files) {
      const parsedName = file.name.split('.');
      const index = parsedName.length - 1;
      const extension = parsedName[index];      
      const name = parsedName.slice(0, -1).join('.');
      const fileContent = await readFileAsync(file.originFileObj);
      const base64Data = btoa(fileContent);
      const attachedFile = {
          AttachedFile: base64Data,
          Appointment: "Individual",
          NameFile: name,
          ExtensionFile: extension
      };  
      formattedFiles.push(attachedFile);   
    }
    if(formattedFiles.length === 0) {
      if(changedData.hasOwnProperty('AttachedFiles')) delete changedData.AttachedFiles;
    } else {
      changedData.AttachedFiles = formattedFiles;
    }
  };

  const props = {
    name: 'file',
    multiple: true,
    beforeUpload: handleBeforeUpload,
    onChange(info) {
      const { status } = info.file;
      setFilesCount(info.fileList.length);
      if(info.fileList.length === 10) message.warning('Достигнуто максимально допустимое количество файлов 10!');
      if (status !== 'uploading') {
        handleUpload(info.fileList);
      }
    },
  };

  const handleChange = (event, option) => {
    let { name, value, dataset } = typeof event === "string" ? option : event.target;
    const { parent } = dataset;
    if(name === 'BirthDate' || name === 'DocDateIssued' || name === 'DocValid' || name === 'DocInfoValid') value += 'T00:00:00';
    if (parent) {
      if(dataset.grandparent) {
        if(dataset.uid) {
          setFormData(prevState => ({
            ...prevState,
            [dataset.grandparent] : {
              ...prevState[dataset.grandparent],
              [parent]: {
                ...prevState[parent],
                [name]: value,
                UID: dataset.uid
              }
            }
          }));
          setChangedData(prevState => ({
            ...prevState,
            [dataset.grandparent] : {
              ...prevState[dataset.grandparent],
              [parent]: {
                ...prevState[parent],
                [name]: value,
                UID: dataset.uid
              }
            }
          }));
        } else {
          setFormData(prevState => ({
            ...prevState,
            [dataset.grandparent]: {
              ...prevState[dataset.grandparent],
              [parent]: {
                ...prevState[parent],
                [name]: value
              }
            }
          }));
          setChangedData(prevState => ({
            ...prevState,
            [dataset.grandparent]: {
              ...prevState[dataset.grandparent],
              [parent]: {
                ...prevState[parent],
                [name]: value
              }
            }
          }));
        }
      } else {
        if (name === "extNumber") {
          let tempNumber = workPhone;
          if(formData.WorkPhoneNumber.value.includes(', доб.')) tempNumber = formData.WorkPhoneNumber.value.split(',')[0];
          setFormData(prevState => ({
            ...prevState,
            [parent]: {
              ...prevState[parent],
              [name]: value,
              value: `${tempNumber}, доб. ${value}`
            }
          }));
          setChangedData(prevState => ({
            ...prevState,
            [parent]: {
              ...prevState[parent],
              value: `${tempNumber}, доб. ${value}`
            }
          }));
        } else {
          if(dataset.uid) {
            setFormData(prevState => ({
              ...prevState,
              [parent]: {
                ...prevState[parent],
                [name]: value,
                UID: dataset.uid
              }
            }));
            setChangedData(prevState => ({
              ...prevState,
              [parent]: {
                ...prevState[parent],
                [name]: value,
                UID: dataset.uid
              }
            }));
          } else {
            setFormData(prevState => ({
              ...prevState,
              [parent]: {
                ...prevState[parent],
                [name]: value
              }
            }));
            setChangedData(prevState => ({
              ...prevState,
              [parent]: {
                ...prevState[parent],
                [name]: value
              }
            }));
          }
        }
      }
    } else {
      setFormData(prevState => ({
        ...prevState,
        [name]: value
      }));
      setChangedData(prevState => ({
        ...prevState,
        [name]: value
      }));
    }
  };

  const handlePhoneChange = (event, isWorkPhone) => {
    const inputType = event.nativeEvent.inputType;
    const isDeleteContentBackward = inputType === 'deleteContentBackward' ? true : false;
    if(isWorkPhone) {
      const { value } = event.target;
      let numberValue = isDeleteContentBackward ? value : extractNumberFormat(value);
      let formattedNumber = numberValue === '' ? value : numberValue;
      const newWorkPhoneNumber = {
        areaCode: "",
        comment: "",
        countryCode: "",
        extNumber: "",
        number: "",
        value: ""
      };
      if (newWorkPhoneNumber.extNumber.length > 0) {
        newWorkPhoneNumber.value = `${formattedNumber}, доб. ${newWorkPhoneNumber.extNumber}`;
      } else {
        newWorkPhoneNumber.value = formattedNumber;
      }
      setWorkPhone(formattedNumber);
      setFormData(prevState => ({
        ...prevState,
        WorkPhoneNumber: newWorkPhoneNumber
      }));
      setChangedData(prevState => ({
        ...prevState,
        WorkPhoneNumber: newWorkPhoneNumber
      }));
    } else {
      const { name, value, dataset } = event.target;
      const { parent } = dataset;
      let numberValue = isDeleteContentBackward ? value : extractNumberFormat(value);
      if (parent) {
        setFormData(prevState => {
          const updatedParent = {
            ...prevState[parent],
            [name]: numberValue === '' ? value : numberValue
          };
          const newPhoneNumber = {
            areaCode: "",
            comment: "",
            countryCode: "",
            extNumber: "",
            number: "",
            value: ""
          };      
          newPhoneNumber.value = numberValue === '' ? value : numberValue;
          setChangedData(prevState => ({
            ...prevState,
            [parent]: newPhoneNumber
          }));
          return {
            ...prevState,
            [parent]: updatedParent
          };
        });
      } else {
        setFormData(prevState => {
          const updatedData = {
            ...prevState,
            [name]: numberValue === '' ? value : numberValue
          };
          const newPhoneNumber = {
            areaCode: "",
            comment: "",
            countryCode: "",
            extNumber: "",
            number: "",
            value: ""
          };      
          newPhoneNumber.value = numberValue === '' ? value : numberValue;
          setChangedData(prevState => ({
            ...prevState,
            [parent]: newPhoneNumber
          }));  
          return updatedData;
        });
      }
    }
  };  
  
  const loadImage = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = (event) => {
        const base64String = event.target.result.split(',')[1];
        setFormData(prevState => {
            const updatedState = {
                ...prevState,
                Photo: base64String
            };
            return updatedState;
        });
        setChangedData(prevState => {
            const updatedState = {
                ...prevState,
                Photo: base64String
            };
            return updatedState;
        });
    };
    reader.readAsDataURL(file);
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => setImage(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const handleCropImage = () => {
    const base64String = cropperRef.current.getCanvas().toDataURL().split(',')[1];
    if (cropperRef.current) {
      const croppedImage = base64String;
      setFormData((prevState) => ({
        ...prevState,
        Photo: croppedImage,
      }));
      setChangedData(prevState => {
          const updatedState = {
              ...prevState,
              Photo: base64String
          };
          return updatedState;
      });
      handleClosePhotoCropperModal();
    }
  }

  const zoomIn = () => {
    if(scale < 3) {
      cropperRef.current.zoomImage(1.1);
      setScale(scale+0.1);
    }
  }
  const zoomOut = () => {
    if(scale > 0.7) {
      cropperRef.current.zoomImage(0.9091);
      setScale(scale-0.1);      
    }
  }

  const handleZoomChange = (value) => {
    if(value < scale) zoomOut();
    else zoomIn();
    setScale(value);
  }

  const handleUploadNewPhoto = () => {
    setImage(null);
    setScale(1);
  }
  
  const handleClosePhotoCropperModal = () => {
    setShowPhotoCropperModal(false);
    setImage(null);
    setScale(1);
  }
  
  const handlePassportClear = () => {  
      setShowPassportModal(false);
  };

  const extractNumberFormat = (number) => {
		const phoneUtil = PhoneNumberUtil.getInstance();
		let phoneNumber = '';
		try {
      const parsedPhoneNumber = phoneUtil.parseAndKeepRawInput(number, 'ZZ');
      const formattedPhoneNumber = phoneUtil.format(parsedPhoneNumber, PhoneNumberFormat.RFC3966);
      const cleanedPhoneNumber = formattedPhoneNumber.replace('tel:', '');
      const parts = cleanedPhoneNumber.split('-');
      phoneNumber = '';
      for(let i = 0; i < parts.length; i++) {
        if(i < 2) phoneNumber += `${parts[i]} `
        else phoneNumber += `${parts[i]}`
      }
      return phoneNumber;
		} catch (error) {
			return '';
		}
	}

  const updateChangedData = (key, data) => {
    setChangedData(prevState => ({
        ...prevState,
        [key]: data
    }));
  };

  const handleRegistrationAddressChange = (e, option) => {
    let { name, value, dataset } = typeof e === "string" ? option : e.target;
    const { parent } = dataset;

    updateChangedData('RegistrationAddress', registrationAddress);
    setRegistrationAddress(prevState => {
      if (parent) {
        let viewAddress;
        if(parent === "Country") {
          viewAddress = value;
          registrationAddress.City.City = "";
          registrationAddress.Street = "";
          registrationAddress.House = "";
          updateChangedData('RegistrationAddress', {
            ...prevState,
            [parent]: {
              ...prevState[parent],
              [name]: value,
              UID: dataset.uid
            },
            ViewAddresses: viewAddress
          });
        } else if (parent === "City") {
          viewAddress = `${registrationAddress.Country.Name}, ${value}`;
          registrationAddress.Street = "";
          registrationAddress.House = "";
          updateChangedData('RegistrationAddress', {
            ...prevState,
            [parent]: {
              ...prevState[parent],
              [name]: value
            },
            ViewAddresses: viewAddress
          });
        }
        return {
          ...prevState,
          [parent]: {
            ...prevState[parent],
            [name]: value
          },
          ViewAddresses: viewAddress
        };
      } else {
        let viewAddress;
        if (name === "Street") {
          viewAddress = `${registrationAddress.Country.Name}, ${registrationAddress.City.City}, ${value}`;
          if (registrationAddress.House.length > 0) viewAddress += `, ${registrationAddress.House}`;
        } else if (name === "House") {
          viewAddress = `${registrationAddress.Country.Name}, ${registrationAddress.City.City}, ${registrationAddress.Street}, ${value}`;
        } else {
          viewAddress = prevState.ViewAddresses
        }
        updateChangedData('RegistrationAddress', {
          ...prevState,
          [name]: value,
          ViewAddresses: viewAddress
        });
        return {
          ...prevState,
          [name]: value,
          ViewAddresses: viewAddress
        };
      }
    });
    setRegAddressRegion({
      value: "",
      fias_id: "",
      iso_code: ""
    });
    setRegAddressArea({
      value: "",
      fias_id: ""
    });
    setRegAddressCity({
      value: "",
      city_fias_id: "",
      settlement_fias_id: ""
    });
    setRegAddressStreet('');
    setRegAddressHouse('');
    setRegAddressFlat('');
    regRegionRef.current.state.query = '';
    regCityRef.current.state.query = '';
    regStreetRef.current.state.query = '';
  };

  const handleRegistrationCountryChange = (value) => {
    let parent = 'Country';
    setRegistrationAddress(prevState => ({
      ...prevState,
      [parent]: {
        ...prevState[parent],
        Name: value,
        UID: ''
      },
      ViewAddresses: value
    }));
    setChangedData(prevState => {
      return {
        ...prevState,
        RegistrationAddress: {
          ...prevState['RegistrationAddress'],
          ViewAddresses: value
        }
      };
    })
    setRegAddressRegion({
      value: "",
      fias_id: "",
      iso_code: ""
    });
    setRegAddressArea({
      value: "",
      fias_id: ""
    });
    setRegAddressCity({
      value: "",
      city_fias_idfias_id: "",
      settlement_fias_id: ""
    });
    setRegAddressStreet('');
    setRegAddressHouse('');
    setRegAddressFlat('');
    regRegionRef.current.state.query = '';
    regCityRef.current.state.query = '';
    regStreetRef.current.state.query = '';
  }

  const handleRegistrationRegionChange = (data) => {
    setRegAddressRegion({
      value: data.value,
      fias_id: data.data.region_fias_id,
      iso_code: data.data.region_iso_code
    });
    setRegAddressArea({
      value: "",
      fias_id: ""
    });
    setRegAddressCity({
      value: "",
      city_fias_id: "",
      settlement_fias_id: ""
    });
    setRegAddressStreet('');
    setRegAddressHouse('');
    setRegAddressFlat('');
    regCityRef.current.state.query = '';
    regStreetRef.current.state.query = '';
    let viewAddress = `${registrationAddress.Country.Name}, ${data.value}`;
    setRegistrationAddress(prevState => {
      return {
        ...prevState,
        ViewAddresses: viewAddress
      };
    })
    setChangedData(prevState => {
      return {
        ...prevState,
        RegistrationAddress: {
          ...prevState['RegistrationAddress'],
          ViewAddresses: viewAddress,
          AddressType: "ВСвободнойФорме",
          City: {
            Subject: "",
            Area: "",
            MunicipalDistrict: "",
            City: "",
            Village: "",
            IntracityDistrict: "",
            PopulationPoint: "",
            Territory: "",
          },
          Street: "",
          HouseType: "",
          TypeBuilding: "",
          TypePremises: "",
          House: "",
          Building: "",
          Premises: "",
          Index: "",
        }
      };
    })
  }

  const handleRegistrationRegionInput = (e) => {
    setRegAddressRegion({
      value: e.target.value,
      fias_id: "",
      iso_code: ""
    });
    setRegAddressArea({
      value: "",
      fias_id: ""
    });
    setRegAddressCity({
      value: "",
      city_fias_id: "",
      settlement_fias_id: ""
    });
    setRegAddressStreet('');
    setRegAddressHouse('');
    setRegAddressFlat('');
    regCityRef.current.state.query = '';
    regStreetRef.current.state.query = '';
    let viewAddress = `${registrationAddress.Country.Name}, ${e.target.value}`;
    setRegistrationAddress(prevState => {
      return {
        ...prevState,
        ViewAddresses: viewAddress
      };
    })
    setChangedData(prevState => {
      return {
        ...prevState,
        RegistrationAddress: {
          ...prevState['RegistrationAddress'],
          ViewAddresses: viewAddress,
          AddressType: "ВСвободнойФорме",
          City: {
            Subject: "",
            Area: "",
            MunicipalDistrict: "",
            City: "",
            Village: "",
            IntracityDistrict: "",
            PopulationPoint: "",
            Territory: "",
          },
          Street: "",
          HouseType: "",
          TypeBuilding: "",
          TypePremises: "",
          House: "",
          Building: "",
          Premises: "",
          Index: "",
        }
      };
    })
  }

  const handleRegistrationAreaChange = (data) => {
    setRegAddressArea({
      value: data.value,
      fias_id: data.data.area_fias_id
    });
    setRegAddressCity({
      value: "",
      fias_id: ""
    });
    setRegAddressStreet('');
    setRegAddressHouse('');
    setRegAddressFlat('');
    let viewAddress = `${registrationAddress.Country.Name}${regAddressRegion.value ? ', '+regAddressRegion.value : ''}${data.value ? ', '+data.value : ''}`;
    setRegistrationAddress(prevState => {
      return {
        ...prevState,
        ViewAddresses: viewAddress
      };
    })
    setChangedData(prevState => {
      return {
        ...prevState,
        RegistrationAddress: {
          ...prevState['RegistrationAddress'],
          ViewAddresses: viewAddress,
          AddressType: "ВСвободнойФорме",
          City: {
            Subject: "",
            Area: "",
            MunicipalDistrict: "",
            City: "",
            Village: "",
            IntracityDistrict: "",
            PopulationPoint: "",
            Territory: "",
          },
          Street: "",
          HouseType: "",
          TypeBuilding: "",
          TypePremises: "",
          House: "",
          Building: "",
          Premises: "",
          Index: "",
        }
      };
    })
  }

  const handleRegistrationAreaInput = (e) => {
    setRegAddressArea({
      value: e.target.value,
      fias_id: ""
    });
    setRegAddressCity({
      value: "",
      fias_id: ""
    });
    setRegAddressStreet('');
    setRegAddressHouse('');
    setRegAddressFlat('');
    let viewAddress = `${registrationAddress.Country.Name}${regAddressRegion.value ? ', '+regAddressRegion.value : ''}${e.target.value ? ', '+e.target.value : ''}`;
    setRegistrationAddress(prevState => {
      return {
        ...prevState,
        ViewAddresses: viewAddress
      };
    })
    setChangedData(prevState => {
      return {
        ...prevState,
        RegistrationAddress: {
          ...prevState['RegistrationAddress'],
          ViewAddresses: viewAddress,
          AddressType: "ВСвободнойФорме",
          City: {
            Subject: "",
            Area: "",
            MunicipalDistrict: "",
            City: "",
            Village: "",
            IntracityDistrict: "",
            PopulationPoint: "",
            Territory: "",
          },
          Street: "",
          HouseType: "",
          TypeBuilding: "",
          TypePremises: "",
          House: "",
          Building: "",
          Premises: "",
          Index: "",
        }
      };
    })
  }

  const handleRegistrationCityChange = (data) => {
    if (data.data.city_fias_id) {
      setRegAddressCity({
        value: data.value,
        city_fias_id: data.data.city_fias_id,
        settlement_fias_id: ""
      });
    } else {
      setRegAddressCity({
        value: data.value,
        city_fias_id: "",
        settlement_fias_id: data.data.settlement_fias_id
      });
    }
    setRegAddressStreet('');
    setRegAddressHouse('');
    setRegAddressFlat('');
    regStreetRef.current.state.query = '';
    let viewAddress = `${registrationAddress.Country.Name}${regAddressRegion.value ? ', '+regAddressRegion.value : ''}${regAddressArea.value ? ', '+regAddressArea.value : ''}${data.value ? ', '+data.value : ''}`;
    setRegistrationAddress(prevState => {
      return {
        ...prevState,
        ViewAddresses: viewAddress
      };
    })
    setChangedData(prevState => {
      return {
        ...prevState,
        RegistrationAddress: {
          ...prevState['RegistrationAddress'],
          ViewAddresses: viewAddress,
          AddressType: "ВСвободнойФорме",
          City: {
            Subject: "",
            Area: "",
            MunicipalDistrict: "",
            City: "",
            Village: "",
            IntracityDistrict: "",
            PopulationPoint: "",
            Territory: "",
          },
          Street: "",
          HouseType: "",
          TypeBuilding: "",
          TypePremises: "",
          House: "",
          Building: "",
          Premises: "",
          Index: "",
        }
      };
    })
  }

  const handleRegistrationCityInput = (e) => {
    setRegAddressCity({
      value: e.target.value,
      city_fias_id: "",
      settlement_fias_id: "",
    });
    setRegAddressStreet('');
    setRegAddressHouse('');
    setRegAddressFlat('');
    regStreetRef.current.state.query = '';
    let viewAddress = `${registrationAddress.Country.Name}${regAddressRegion.value ? ', '+regAddressRegion.value : ''}${regAddressArea.value ? ', '+regAddressArea.value : ''}${e.target.value ? ', '+e.target.value : ''}`;
    setRegistrationAddress(prevState => {
      return {
        ...prevState,
        ViewAddresses: viewAddress
      };
    })
    setChangedData(prevState => {
      return {
        ...prevState,
        RegistrationAddress: {
          ...prevState['RegistrationAddress'],
          ViewAddresses: viewAddress,
          AddressType: "ВСвободнойФорме",
          City: {
            Subject: "",
            Area: "",
            MunicipalDistrict: "",
            City: "",
            Village: "",
            IntracityDistrict: "",
            PopulationPoint: "",
            Territory: "",
          },
          Street: "",
          HouseType: "",
          TypeBuilding: "",
          TypePremises: "",
          House: "",
          Building: "",
          Premises: "",
          Index: "",
        }
      };
    })
  }

  const handleRegistrationStreetChange = (data) => {
    setRegAddressStreet(data.value);
    setRegAddressHouse('');
    setRegAddressFlat('');
    let viewAddress = `${registrationAddress.Country.Name}${regAddressRegion.value ? ', '+regAddressRegion.value : ''}${regAddressArea.value ? ', '+regAddressArea.value : ''}${regAddressCity.value ? ', '+regAddressCity.value : ''}${data.value ? ', '+data.value : ''}`;
    setRegistrationAddress(prevState => {
      return {
        ...prevState,
        ViewAddresses: viewAddress
      };
    })
    setChangedData(prevState => {
      return {
        ...prevState,
        RegistrationAddress: {
          ...prevState['RegistrationAddress'],
          ViewAddresses: viewAddress,
          AddressType: "ВСвободнойФорме",
          City: {
            Subject: "",
            Area: "",
            MunicipalDistrict: "",
            City: "",
            Village: "",
            IntracityDistrict: "",
            PopulationPoint: "",
            Territory: "",
          },
          Street: "",
          HouseType: "",
          TypeBuilding: "",
          TypePremises: "",
          House: "",
          Building: "",
          Premises: "",
          Index: "",
        }
      };
    })
  }

  const handleRegistrationStreetInput = (e) => {
    setRegAddressStreet(e.target.value);
    setRegAddressHouse('');
    setRegAddressFlat('');
    let viewAddress = `${registrationAddress.Country.Name}${regAddressRegion.value ? ', '+regAddressRegion.value : ''}${regAddressArea.value ? ', '+regAddressArea.value : ''}${regAddressCity.value ? ', '+regAddressCity.value : ''}${e.target.value ? ', '+e.target.value : ''}`;
    setRegistrationAddress(prevState => {
      return {
        ...prevState,
        ViewAddresses: viewAddress
      };
    })
    setChangedData(prevState => {
      return {
        ...prevState,
        RegistrationAddress: {
          ...prevState['RegistrationAddress'],
          ViewAddresses: viewAddress,
          AddressType: "ВСвободнойФорме",
          City: {
            Subject: "",
            Area: "",
            MunicipalDistrict: "",
            City: "",
            Village: "",
            IntracityDistrict: "",
            PopulationPoint: "",
            Territory: "",
          },
          Street: "",
          HouseType: "",
          TypeBuilding: "",
          TypePremises: "",
          House: "",
          Building: "",
          Premises: "",
          Index: "",
        }
      };
    })
  }

  const handleRegistrationHouseChange = (e) => {
    setRegAddressHouse(e.target.value);
    setRegAddressFlat('');
    let viewAddress = `${registrationAddress.Country.Name}${regAddressRegion.value ? ', '+regAddressRegion.value : ''}${regAddressArea.value ? ', '+regAddressArea.value : ''}${regAddressCity.value ? ', '+regAddressCity.value : ''}${regAddressStreet ? ', '+regAddressStreet : ''}${e.target.value ? ', д. '+e.target.value : ''}`;
    setRegistrationAddress(prevState => {
      return {
        ...prevState,
        ViewAddresses: viewAddress
      };
    })
    setChangedData(prevState => {
      return {
        ...prevState,
        RegistrationAddress: {
          ...prevState['RegistrationAddress'],
          ViewAddresses: viewAddress,
          AddressType: "ВСвободнойФорме",
          City: {
            Subject: "",
            Area: "",
            MunicipalDistrict: "",
            City: "",
            Village: "",
            IntracityDistrict: "",
            PopulationPoint: "",
            Territory: "",
          },
          Street: "",
          HouseType: "",
          TypeBuilding: "",
          TypePremises: "",
          House: "",
          Building: "",
          Premises: "",
          Index: "",
        }
      };
    })
  }
  
  const handleRegistrationFlatChange = (e) => {
    setRegAddressFlat(e.target.value);
    let viewAddress = `${registrationAddress.Country.Name}${regAddressRegion.value ? ', '+regAddressRegion.value : ''}${regAddressArea.value ? ', '+regAddressArea.value : ''}${regAddressCity.value ? ', '+regAddressCity.value : ''}${regAddressStreet ? ', '+regAddressStreet : ''}${regAddressHouse ? ', д. '+regAddressHouse : ''}${e.target.value ? ', кв. '+e.target.value : ''}`;
    setRegistrationAddress(prevState => {
      return {
        ...prevState,
        ViewAddresses: viewAddress
      };
    })
    setChangedData(prevState => {
      return {
        ...prevState,
        RegistrationAddress: {
          ...prevState['RegistrationAddress'],
          ViewAddresses: viewAddress,
          AddressType: "ВСвободнойФорме",
          City: {
            Subject: "",
            Area: "",
            MunicipalDistrict: "",
            City: "",
            Village: "",
            IntracityDistrict: "",
            PopulationPoint: "",
            Territory: "",
          },
          Street: "",
          HouseType: "",
          TypeBuilding: "",
          TypePremises: "",
          House: "",
          Building: "",
          Premises: "",
          Index: "",
        }
      };
    })
  }
  
  const handleResidentialAddressChange = (e, option) => {
    let { name, value, dataset } = typeof e === "string" ? option : e.target;
    const { parent } = dataset;

    setResidentialAddress(prevState => {
      if (parent) {
        let viewAddress;
        if(parent === "Country") {
          viewAddress = value;
          residentialAddress.City.City = "";
          residentialAddress.Street = "";
          residentialAddress.House = "";
          updateChangedData('ResidenceAddress', {
            ...prevState,
            [parent]: {
              ...prevState[parent],
              [name]: value,
              UID: dataset.uid
            },
            ViewAddresses: viewAddress
          });
        } else if (parent === "City") {
          viewAddress = `${residentialAddress.Country.Name}, ${value}`;
          residentialAddress.Street = "";
          residentialAddress.House = "";
          updateChangedData('ResidenceAddress', {
            ...prevState,
            [parent]: {
              ...prevState[parent],
              [name]: value
            },
            ViewAddresses: viewAddress
          });
        }
        return {
          ...prevState,
          [parent]: {
            ...prevState[parent],
            [name]: value
          },
          ViewAddresses: viewAddress
        };
      } else {
        let viewAddress;
        if (name === "Street") {
          viewAddress = `${residentialAddress.Country.Name}, ${residentialAddress.City.City}, ${value}`;
          if (residentialAddress.House.length > 0) viewAddress += `, ${residentialAddress.House}`;
        } else if (name === "House") {
          viewAddress = `${residentialAddress.Country.Name}, ${residentialAddress.City.City}, ${residentialAddress.Street}, ${value}`;
        } else {
          viewAddress = prevState.ViewAddresses
        }
        updateChangedData('ResidenceAddress', {
          ...prevState,
          [name]: value,
          ViewAddresses: viewAddress
        });
        return {
          ...prevState,
          [name]: value,
          ViewAddresses: viewAddress
        };
      }
    });
    setResAddressRegion({
      value: "",
      fias_id: "",
      iso_code: ""
    });
    setResAddressArea({
      value: "",
      fias_id: ""
    });
    setResAddressCity({
      value: "",
      city_fias_id: "",
      settlement_fias_id: ""
    });
    setResAddressStreet('');
    setResAddressHouse('');
    setResAddressFlat('');
    resRegionRef.current.state.query = '';
    resCityRef.current.state.query = '';
    resStreetRef.current.state.query = '';
    updateChangedData('ResidenceAddress', residentialAddress);
  };

  const handleResidentialCountryChange = (value) => {
    let parent = 'Country';
    setResidentialAddress(prevState => ({
        ...prevState,
        [parent]: {
            ...prevState[parent],
            Name: value,
            UID: ''
        },
        ViewAddresses: value
    }));
    setResAddressRegion({
      value: "",
      fias_id: "",
      iso_code: ""
    });
    setResAddressArea({
      value: "",
      fias_id: ""
    });
    setResAddressCity({
      value: "",
      city_fias_id: "",
      settlement_fias_id: ""
    });
    setResAddressStreet('');
    setResAddressHouse('');
    setResAddressFlat('');
    resRegionRef.current.state.query = '';
    resCityRef.current.state.query = '';
    resStreetRef.current.state.query = '';
    setChangedData(prevState => {
      return {
        ...prevState,
        ResidenceAddress: {
          ...prevState['ResidenceAddress'],
          ViewAddresses: value
        }
      };
    })
  }

  const handleResidentialRegionChange = (data) => {
    setResAddressRegion({
      value: data.value,
      fias_id: data.data.region_fias_id,
      iso_code: data.data.region_iso_code
    });
    setResAddressArea({
      value: "",
      fias_id: ""
    });
    setResAddressCity({
      value: "",
      city_fias_id: "",
      settlement_fias_id: ""
    });
    setResAddressStreet('');
    setResAddressHouse('');
    setResAddressFlat('');
    resCityRef.current.state.query = '';
    resStreetRef.current.state.query = '';
    let viewAddress = `${residentialAddress.Country.Name}, ${data.value}`;
    setResidentialAddress(prevState => {
      return {
        ...prevState,
        ViewAddresses: viewAddress
      };
    })
    setChangedData(prevState => {
      return {
        ...prevState,
        ResidenceAddress: {
          ...prevState['ResidenceAddress'],
          ViewAddresses: viewAddress,
          AddressType: 'ВСвободнойФорме',
          City: {
            Subject: "",
            Area: "",
            MunicipalDistrict: "",
            City: "",
            Village: "",
            IntracityDistrict: "",
            PopulationPoint: "",
            Territory: "",
          },
          Street: "",
          HouseType: "",
          TypeBuilding: "",
          TypePremises: "",
          House: "",
          Building: "",
          Premises: "",
          Index: "",
        }
      };
    })
  }

  const handleResidentialRegionInput = (e) => {
    setResAddressRegion({
      value: e.target.value,
      fias_id: "",
      iso_code: ""
    });
    setResAddressArea({
      value: "",
      fias_id: ""
    });
    setResAddressCity({
      value: "",
      city_fias_id: "",
      settlement_fias_id: ""
    });
    setResAddressStreet('');
    setResAddressHouse('');
    setResAddressFlat('');
    resCityRef.current.state.query = '';
    resStreetRef.current.state.query = '';
    let viewAddress = `${residentialAddress.Country.Name}, ${e.target.value}`;
    setResidentialAddress(prevState => {
      return {
        ...prevState,
        ViewAddresses: viewAddress
      };
    })
    setChangedData(prevState => {
      return {
        ...prevState,
        ResidenceAddress: {
          ...prevState['ResidenceAddress'],
          ViewAddresses: viewAddress,
          AddressType: 'ВСвободнойФорме',
          City: {
            Subject: "",
            Area: "",
            MunicipalDistrict: "",
            City: "",
            Village: "",
            IntracityDistrict: "",
            PopulationPoint: "",
            Territory: "",
          },
          Street: "",
          HouseType: "",
          TypeBuilding: "",
          TypePremises: "",
          House: "",
          Building: "",
          Premises: "",
          Index: "",
        }
      };
    })
  }

  const handleResidentialAreaChange = (data) => {
    setResAddressArea({
      value: data.value,
      fias_id: data.data.area_fias_id
    });
    setResAddressCity({
      value: "",
      fias_id: ""
    });
    setResAddressStreet('');
    setResAddressHouse('');
    setResAddressFlat('');
    let viewAddress = `${residentialAddress.Country.Name}${resAddressRegion.value ? ', '+resAddressRegion.value : ''}${data.value ? ', '+data.value : ''}`;
    setResidentialAddress(prevState => {
      return {
        ...prevState,
        ViewAddresses: viewAddress
      };
    })
    setChangedData(prevState => {
      return {
        ...prevState,
        ResidenceAddress: {
          ...prevState['ResidenceAddress'],
          ViewAddresses: viewAddress,
          AddressType: 'ВСвободнойФорме',
          City: {
            Subject: "",
            Area: "",
            MunicipalDistrict: "",
            City: "",
            Village: "",
            IntracityDistrict: "",
            PopulationPoint: "",
            Territory: "",
          },
          Street: "",
          HouseType: "",
          TypeBuilding: "",
          TypePremises: "",
          House: "",
          Building: "",
          Premises: "",
          Index: "",
        }
      };
    })
  }

  const handleResidentialAreaInput = (e) => {
    setResAddressArea({
      value: e.target.value,
      fias_id: ""
    });
    setResAddressCity({
      value: "",
      fias_id: ""
    });
    setResAddressStreet('');
    setResAddressHouse('');
    setResAddressFlat('');
    let viewAddress = `${residentialAddress.Country.Name}${resAddressRegion.value ? ', '+resAddressRegion.value : ''}${e.target.value ? ', '+e.target.value : ''}`;
    setResidentialAddress(prevState => {
      return {
        ...prevState,
        ViewAddresses: viewAddress
      };
    })
    setChangedData(prevState => {
      return {
        ...prevState,
        ResidenceAddress: {
          ...prevState['ResidenceAddress'],
          ViewAddresses: viewAddress,
          AddressType: 'ВСвободнойФорме',
          City: {
            Subject: "",
            Area: "",
            MunicipalDistrict: "",
            City: "",
            Village: "",
            IntracityDistrict: "",
            PopulationPoint: "",
            Territory: "",
          },
          Street: "",
          HouseType: "",
          TypeBuilding: "",
          TypePremises: "",
          House: "",
          Building: "",
          Premises: "",
          Index: "",
        }
      };
    })
  }

  const handleResidentialCityChange = (data) => {
    if (data.data.city_fias_id) {
      setResAddressCity({
        value: data.value,
        city_fias_id: data.data.city_fias_id,
        settlement_fias_id: ""
      });
    } else {
      setResAddressCity({
        value: data.value,
        city_fias_id: "",
        settlement_fias_id: data.data.settlement_fias_id
      });
    }
    setResAddressStreet('');
    setResAddressHouse('');
    setResAddressFlat('');
    resStreetRef.current.state.query = '';
    let viewAddress = `${residentialAddress.Country.Name}${resAddressRegion.value ? ', '+resAddressRegion.value : ''}${resAddressArea.value ? ', '+resAddressArea.value : ''}${data.value ? ', '+data.value : ''}`;
    setResidentialAddress(prevState => {
      return {
        ...prevState,
        ViewAddresses: viewAddress
      };
    })
    setChangedData(prevState => {
      return {
        ...prevState,
        ResidenceAddress: {
          ...prevState['ResidenceAddress'],
          ViewAddresses: viewAddress,
          AddressType: 'ВСвободнойФорме',
          City: {
            Subject: "",
            Area: "",
            MunicipalDistrict: "",
            City: "",
            Village: "",
            IntracityDistrict: "",
            PopulationPoint: "",
            Territory: "",
          },
          Street: "",
          HouseType: "",
          TypeBuilding: "",
          TypePremises: "",
          House: "",
          Building: "",
          Premises: "",
          Index: "",
        }
      };
    })
  }

  const handleResidentialCityInput = (e) => {
    setResAddressCity({
      value: e.target.value,
      city_fias_id: "",
      settlement_fias_id: ""
    });
    setResAddressStreet('');
    setResAddressHouse('');
    setResAddressFlat('');
    resStreetRef.current.state.query = '';
    let viewAddress = `${residentialAddress.Country.Name}${resAddressRegion.value ? ', '+resAddressRegion.value : ''}${resAddressArea.value ? ', '+resAddressArea.value : ''}${e.target.value ? ', '+e.target.value : ''}`;
    setResidentialAddress(prevState => {
      return {
        ...prevState,
        ViewAddresses: viewAddress
      };
    })
    setChangedData(prevState => {
      return {
        ...prevState,
        ResidenceAddress: {
          ...prevState['ResidenceAddress'],
          ViewAddresses: viewAddress,
          AddressType: 'ВСвободнойФорме',
          City: {
            Subject: "",
            Area: "",
            MunicipalDistrict: "",
            City: "",
            Village: "",
            IntracityDistrict: "",
            PopulationPoint: "",
            Territory: "",
          },
          Street: "",
          HouseType: "",
          TypeBuilding: "",
          TypePremises: "",
          House: "",
          Building: "",
          Premises: "",
          Index: "",
        }
      };
    })
  }

  const handleResidentialStreetChange = (data) => {
    setResAddressStreet(data.value);
    setResAddressHouse('');
    setResAddressFlat('');
    let viewAddress = `${residentialAddress.Country.Name}${resAddressRegion.value ? ', '+resAddressRegion.value : ''}${resAddressArea.value ? ', '+resAddressArea.value : ''}${resAddressCity.value ? ', '+resAddressCity.value : ''}${data.value ? ', '+data.value : ''}`;
    setResidentialAddress(prevState => {
      return {
        ...prevState,
        ViewAddresses: viewAddress
      };
    })
    setChangedData(prevState => {
      return {
        ...prevState,
        ResidenceAddress: {
          ...prevState['ResidenceAddress'],
          ViewAddresses: viewAddress,
          AddressType: 'ВСвободнойФорме',
          City: {
            Subject: "",
            Area: "",
            MunicipalDistrict: "",
            City: "",
            Village: "",
            IntracityDistrict: "",
            PopulationPoint: "",
            Territory: "",
          },
          Street: "",
          HouseType: "",
          TypeBuilding: "",
          TypePremises: "",
          House: "",
          Building: "",
          Premises: "",
          Index: "",
        }
      };
    })
  }

  const handleResidentialStreetInput = (e) => {
    setResAddressStreet(e.target.value);
    setResAddressHouse('');
    setResAddressFlat('');
    let viewAddress = `${residentialAddress.Country.Name}${resAddressRegion.value ? ', '+resAddressRegion.value : ''}${resAddressArea.value ? ', '+resAddressArea.value : ''}${resAddressCity.value ? ', '+resAddressCity.value : ''}${e.target.value ? ', '+e.target.value : ''}`;
    setResidentialAddress(prevState => {
      return {
        ...prevState,
        ViewAddresses: viewAddress
      };
    })
    setChangedData(prevState => {
      return {
        ...prevState,
        ResidenceAddress: {
          ...prevState['ResidenceAddress'],
          ViewAddresses: viewAddress,
          AddressType: 'ВСвободнойФорме',
          City: {
            Subject: "",
            Area: "",
            MunicipalDistrict: "",
            City: "",
            Village: "",
            IntracityDistrict: "",
            PopulationPoint: "",
            Territory: "",
          },
          Street: "",
          HouseType: "",
          TypeBuilding: "",
          TypePremises: "",
          House: "",
          Building: "",
          Premises: "",
          Index: "",
        }
      };
    })
  }

  const handleResidentialHouseChange = (e) => {
    setResAddressHouse(e.target.value);
    setResAddressFlat('');
    let viewAddress = `${residentialAddress.Country.Name}${resAddressRegion.value ? ', '+resAddressRegion.value : ''}${resAddressArea.value ? ', '+resAddressArea.value : ''}${resAddressCity.value ? ', '+resAddressCity.value : ''}${resAddressStreet ? ', '+resAddressStreet : ''}${e.target.value ? ', д. '+e.target.value : ''}`;
    setResidentialAddress(prevState => {
      return {
        ...prevState,
        ViewAddresses: viewAddress
      };
    })
    setChangedData(prevState => {
      return {
        ...prevState,
        ResidenceAddress: {
          ...prevState['ResidenceAddress'],
          ViewAddresses: viewAddress,
          AddressType: 'ВСвободнойФорме',
          City: {
            Subject: "",
            Area: "",
            MunicipalDistrict: "",
            City: "",
            Village: "",
            IntracityDistrict: "",
            PopulationPoint: "",
            Territory: "",
          },
          Street: "",
          HouseType: "",
          TypeBuilding: "",
          TypePremises: "",
          House: "",
          Building: "",
          Premises: "",
          Index: "",
        }
      };
    })
  }
  
  const handleResidentialFlatChange = (e) => {
    setResAddressFlat(e.target.value);
    let viewAddress = `${residentialAddress.Country.Name}${resAddressRegion.value ? ', '+resAddressRegion.value : ''}${resAddressArea.value ? ', '+resAddressArea.value : ''}${resAddressCity.value ? ', '+resAddressCity.value : ''}${resAddressStreet ? ', '+resAddressStreet : ''}${resAddressHouse ? ', д. '+resAddressHouse : ''}${e.target.value ? ', кв. '+e.target.value : ''}`;
    setResidentialAddress(prevState => {
      return {
        ...prevState,
        ViewAddresses: viewAddress
      };
    })
    setChangedData(prevState => {
      return {
        ...prevState,
        ResidenceAddress: {
          ...prevState['ResidenceAddress'],
          ViewAddresses: viewAddress,
          AddressType: 'ВСвободнойФорме',
          City: {
            Subject: "",
            Area: "",
            MunicipalDistrict: "",
            City: "",
            Village: "",
            IntracityDistrict: "",
            PopulationPoint: "",
            Territory: "",
          },
          Street: "",
          HouseType: "",
          TypeBuilding: "",
          TypePremises: "",
          House: "",
          Building: "",
          Premises: "",
          Index: "",
        }
      };
    })
  }

  return (
    <div className='profile-content personal-info-content'>
      {!formData.AllowedEdit && (<p style={{ color: '#c21227', fontSize: '14px', fontWeight: 'bold' }} >*Данные не доступны к редактированию, так как имеется заявка на изменение данных со статусом "На рассмотрении".<br/></p>)}
      <div style={{ margin: '0', display: 'inline' }}>
        <label style={{ cursor: 'inherit' }}>
          <img id="avatar-img" src={imageUrl} width="110px" alt="" style={{ cursor: 'inherit' }} />
        </label>
        {/* Раскомментировать чтобы вернуть возможность менять фото
        <label onClick={() => setShowPhotoCropperModal(true)}>
          <img id="avatar-img" src={imageUrl} width="110px" alt="" />
        </label> */}
      </div>
      <div className='inputGroup'>
        <label className='profile-label'>Ф.И.О.</label><br/>
        <input
          type="text"
          name="Name"
          value={formData.Name}
          onChange={handleChange}
          disabled={true}
        />
      </div>
      <div className='inputGroup'>
        <label className='profile-label'>Аналог Ф.И.О.</label><br/>
        <input
          type="text"
          name="Name"
          value={formData.AnalogName}
          onChange={handleChange}
          disabled={true}
        />
      </div>
      <div className='inputGroup'>
        <label className='profile-label'>Пол</label><br/>
        <Select
          size='small'
          value={formData.Sex.Name ? formData.Sex.Name : undefined}
          onChange={handleChange}
          style={{ width: 200 }}
          placeholder="Выберите пол"
          options={selectors.genders}
          disabled={true}
          />
      </div>
      
      <div className='inputGroup'>
        <label className='profile-label'>Дата рождения</label><br/>
        <input
          type="date"
          name="BirthDate"
          value={formData.BirthDate ? formData.BirthDate.split('T')[0] : ''}
          onChange={handleChange}
          disabled={true}
        />
      </div>
      <div className='inputGroup'>
        <label className='profile-label'>Место рождения</label><br/>
        <p style={{ margin: "0 10px" }}>{birthPlace.length > 2 ? birthPlace : ""}</p>{formData.AllowedEdit && <button type="button" className='btn' onClick={() => setShowBirthPlaceModal(true)}><EditOutlined /></button>}
      </div>
      <div className='inputGroup'>
        <label className='profile-label'>Национальность</label><br/>
        <Select
          size='small'
          value={formData.Nationality.Name ? formData.Nationality.Name : undefined}
          disabled={true}
          onChange={handleChange}
          showSearch
          style={{ width: '100%' }}
          placeholder="Выберите национальность"
          optionFilterProp="children"
          filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
          filterSort={(optionA, optionB) => optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase())}
          notFoundContent={"Введенная национальность отсутствует в базе данных! Вы можете оставить заявку на добавление в системе ServiceDesk"}
          options={selectors.nationalities}
        />
      </div>
      <div className='inputGroup'>
        <label className='profile-label'>Гражданство</label><br/>
        <Select
          size='small'
          value={formData.Citizenship.Name ? formData.Citizenship.Name : undefined}
          onChange={handleChange}
          disabled={true}
          showSearch
          popupMatchSelectWidth={false}
          style={{ width: '100%' }}
          optionFilterProp="children"
          filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
          filterSort={(optionA, optionB) => optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase())}
          placeholder="Выберите гражданство"
          notFoundContent={"Введенное гражданство отсутствует в базе данных! Вы можете оставить заявку на добавление в системе ServiceDesk"}
          options={selectors.citizenshipCountries}
        />
      </div>
      <div className='inputGroup'>
        <label className='profile-label'>Паспортные данные</label><br/>
        <p style={{ marginRight: "10px" }}>{`${formData.Passport.type.Name ? formData.Passport.type.Name : ''} ${formData.Passport.DocSeries ? formData.Passport.DocSeries : ''} ${formData.Passport.DocNumber ? formData.Passport.DocNumber : ''}${formData.Passport.DocDateIssued ? ` от ${formData.Passport.DocDateIssued.split('T')[0]}` : ''}`}</p>{formData.AllowedEdit && <button type="button" className='btn' onClick={() => setShowPassportModal(true)}><EditOutlined /></button>}
      </div>
      <div className='inputGroup'>
        <label className='profile-label'>Семейное положение</label><br/>
        <Select
          size='small'
          value={formData.MaritalStatus.Name ? formData.MaritalStatus.Name : undefined}
          onChange={handleChange}
          popupMatchSelectWidth={false}
          style={{ width: '100%' }}
          placeholder="Выберите семейное положение"
          options={selectors.maritalStatuses}
          disabled={true}
        />
      </div>
      <div className='inputGroup'>
        <label className='profile-label'>Email (рабочий)</label><br/>
        <input type="email" name="EmailWork" value={formData.EmailWork} onChange={handleChange} disabled={formData.AllowedEdit ? false : true} style={{ border: formData.AllowedEdit && '1px solid #1677ff' }} />
      </div>
      <div className='inputGroup'>
        <label className='profile-label'>Email (личный)</label><br/>
        <input type="email" name="EmailPersonal" value={formData.EmailPersonal} onChange={handleChange} disabled={formData.AllowedEdit ? false : true} style={{ border: formData.AllowedEdit && '1px solid #1677ff' }} />
      </div>
      <div className='inputGroup'>
        <label className='profile-label'>ИНН</label><br/>
        <input type="email" name="INN" value={formData.INN} onChange={handleChange} disabled={true} />
      </div>
      <div className='inputGroup'>
        <label className='profile-label'>СНИЛС/ИНПС</label><br/>
        <input type="email" name="INPS" value={formData.INPS} onChange={handleChange} disabled={true} />
      </div>
      <div className='inputGroup'>
        <label className='profile-label'>Телефон (мобильный, служебный)</label><br/>
        <input type="text" data-parent="MobilePhoneWork" name="value" value={formData.MobilePhoneWork.value} onChange={handlePhoneChange}  maxLength={15} disabled={formData.AllowedEdit ? false : true} style={{ border: formData.AllowedEdit && '1px solid #1677ff' }}/>
      </div>
      <div className='inputGroup'>
        <label className='profile-label'>Телефон (мобильный, личный)</label><br/>
        <input type="text" data-parent="MobilePhonePersonal" name="value" value={formData.MobilePhonePersonal.value} onChange={handlePhoneChange} maxLength={15} disabled={formData.AllowedEdit ? false : true} style={{ border: formData.AllowedEdit && '1px solid #1677ff' }}/>
      </div>
      <div className='inputGroup'>
        <label className='profile-label'>Телефон (домашний)</label><br/>
        <input type="text" data-parent="HomePhoneNumber" name="value" value={formData.HomePhoneNumber.value} onChange={handlePhoneChange} maxLength={15} disabled={formData.AllowedEdit ? false : true} style={{ border: formData.AllowedEdit && '1px solid #1677ff' }}/>
      </div>
      <div className='inputGroup'>
        <label className='profile-label'>Телефон (служебный)</label><br/>
        <p style={{ marginRight: "10px" }}>{formData.WorkPhoneNumber.value.length > 10 ? formData.WorkPhoneNumber.value : ''}</p>{formData.AllowedEdit && (<button type="button" className='btn' onClick={() => setShowWorkPhoneNumberModal(true)}><EditOutlined /></button>)}
      </div>
      <table style={{ marginTop: '20px' }} >
          <tbody>
            <tr>
              <td>
                <p className="b">Место прописки: {registrationAddress.ViewAddresses}</p>
                <p style={{ marginRight: "10px" }}>{``}</p>{formData.AllowedEdit && (<button type="button" className='btn' onClick={() => setShowRegistrationAddressModal(true)}><EditOutlined /></button>)}
              </td>
            </tr>
            <tr>
              <td>
                <p className="b">Место жительства: {residentialAddress.ViewAddresses}</p>
                <p style={{ marginRight: "10px" }}>{``}</p>{formData.AllowedEdit && (<button type="button" className='btn' onClick={() => setShowResidentialAddressModal(true)}><EditOutlined /></button>)}
              </td>
            </tr>
          </tbody>
        </table>
      {showPassportModal && (
        <>
        <div className="modal-bg" onClick={handlePassportClear}></div>
        <div className="modal">
          <h4 style={{ textAlign: "center", margin: "5px 0 15px" }}>Паспортные данные</h4><button className='btn' style={{ position: "absolute", top: "8px", right: "16px" }} onClick={handlePassportClear} ><CloseOutlined/></button>
          <table>
            <tbody>
              <tr>
                <td width='40%'><p className="title">Вид документа:</p></td>
                <td width='60%'>
                  <Select
                    size='small'
                    value={formData.Passport.type.Name ? formData.Passport.type.Name : undefined}
                    onChange={handleChange}
                    style={{ width: '100%' }}
                    placeholder='Выберите вид документа'
                    options={selectors.documentTypes}
                  />
                </td>
              </tr>  
              <tr>
                <td width='40%'><p className="title">Серия документа:</p></td>
                <td width='60%'>
                  <input type="text" data-parent="Passport" name="DocSeries" value={formData.Passport.DocSeries} onChange={handleChange} />
                </td>
              </tr>      
              <tr>
                <td width='40%'><p className="title">Номер документа:</p></td>
                <td width='60%'>
                  <input type="text" data-parent="Passport" name="DocNumber" value={formData.Passport.DocNumber} onChange={handleChange} />
                </td>
              </tr>      
              <tr>
                <td width='40%'><p className="title">Кем выдан:</p></td>
                <td width='60%'>
                  <input type="text" data-parent="Passport" name="DocIssued" value={formData.Passport.DocIssued} onChange={handleChange} />
                </td>
              </tr>      
              <tr>
                <td width='40%'><p className="title">Дата выдачи:</p></td>
                <td width='60%'>
                  <input type="date" data-parent="Passport" name="DocDateIssued" value={formData.Passport.DocDateIssued ? formData.Passport.DocDateIssued.split('T')[0] : ''} onChange={handleChange} />
                </td>
              </tr>      
              <tr>
                <td width='40%'><p className="title">Код департамента:</p></td>
                <td width='60%'>
                  <input type="text" data-parent="Passport" name="departmentCode" value={formData.Passport.departmentCode} onChange={handleChange} />
                </td>
              </tr>      
              <tr>
                <td width='40%'><p className="title">Срок действия:</p></td>
                <td width='60%'>
                  <input type="date" data-parent="Passport" name="DocValid" value={formData.Passport.DocValid ? formData.Passport.DocValid.split('T')[0] : ''} onChange={handleChange} />
                </td>
              </tr>      
              <tr>
                <td width='40%'><p className="title">Сведения о документе действует с:</p></td>
                <td width='60%'>
                  <input type="date" data-parent="Passport" name="DocInfoValid" value={formData.Passport.DocInfoValid ? formData.Passport.DocInfoValid.split('T')[0] : ''} onChange={handleChange} />
                </td>
              </tr>     
            </tbody>
          </table>
          <div style={{ marginTop: "32px" }}></div>
          <button className='btn' style={{ position: "absolute", bottom: "8px", right: "16px" }} onClick={() => setShowPassportModal(false)} >ОК</button>
        </div>
        </>
      )}
      {showWorkPhoneNumberModal && (
        <>
        <div className="modal-bg" onClick={() => setShowWorkPhoneNumberModal(false)}></div>
        <div className="modal">
          <h4 style={{ textAlign: "center", margin: "5px 0 15px" }}>Телефон (служебный)</h4><button type="button" className='btn' style={{ position: "absolute", top: "8px", right: "16px" }} onClick={() => setShowWorkPhoneNumberModal(false)} ><CloseOutlined /></button>
          <table>
            <tbody>       
              <tr>
                <td width='40%'><p className="title">Номер:</p></td>
                <td width='60%'>
                  <input type="text" data-parent="WorkPhoneNumber" name="Number" value={workPhone} onChange={(event) => handlePhoneChange(event, true)} maxLength={15}  />
                </td>
              </tr>        
              <tr>
                <td width='40%'><p className="title">Добавочный номер:</p></td>
                <td width='60%'>
                  <input type="number" data-parent="WorkPhoneNumber" name="extNumber" value={formData.WorkPhoneNumber.extNumber} onChange={handleChange} />
                </td>
              </tr>        
              <tr>
                <td width='40%'><p className="title">Представление:</p></td>
                <td width='60%'>
                  <input type="text" disabled data-parent="WorkPhoneNumber" name="value" value={formData.WorkPhoneNumber.value.length > 10 ? formData.WorkPhoneNumber.value : ''} onChange={handleChange} style={{ width: "100%" }} />
                </td>
              </tr>        
            </tbody>
          </table>
          <div style={{ marginTop: "32px" }}></div>
          <button className='btn' style={{ position: "absolute", bottom: "8px", right: "16px" }} onClick={() => setShowWorkPhoneNumberModal(false)} >ОК</button>
        </div>
        </>
      )}
      {showBirthPlaceModal && (
        <>
        <div className="modal-bg" onClick={() => setShowBirthPlaceModal(false)}></div>
        <div className="modal">
          <h4 style={{ textAlign: "center", margin: "5px 0 15px" }}>Место рождения</h4><button type="button" className='btn' style={{ position: "absolute", top: "8px", right: "16px" }} onClick={() => setShowBirthPlaceModal(false)} ><CloseOutlined /></button>
          <table>
            <tbody> 
              <tr>
                <td width='40%'><p className="title">Страна:</p></td>
                <td width='60%'>
                  <Select
                    size='small'
                    value={formData.BirthPlace.Country.Name ? formData.BirthPlace.Country.Name : undefined}
                    onChange={handleChange}
                    showSearch
                    style={{ width: '100%' }}
                    optionFilterProp="children"
                    filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                    filterSort={(optionA, optionB) => optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase())}
                    placeholder="Выберите страну"
                    notFoundContent={"Введенная страна отсутствует в базе данных! Вы можете оставить заявку на добавление в системе ServiceDesk"}
                    options={selectors.birthPlaceCountries}
                  />
                </td>
              </tr>         
              <tr>
                <td width='40%'><p className="title">Город:</p></td>
                <td width='60%'>
                  <input type="text" data-parent="BirthPlace" name="City" value={formData.BirthPlace.City} onChange={handleChange} />
                </td>
              </tr>         
            </tbody>
          </table>
          <div style={{ marginTop: "32px" }}></div>
          <button className='btn' style={{ position: "absolute", bottom: "8px", right: "16px" }} onClick={() => setShowBirthPlaceModal(false)} >ОК</button>
        </div>
        </>
      )}
      {showRegistrationAddressModal && (
          <>
            <div className="modal-bg"></div>
            <div className="modal">
            <h4 style={{ textAlign: "center", margin: "5px 0 15px" }}>Место прописки</h4><button className='btn' style={{ position: "absolute", top: "8px", right: "16px" }} onClick={() => setShowRegistrationAddressModal(false)} ><CloseOutlined /></button>
              <table>
                <tbody>
                  <tr>
                    <td width='40%'><p className="title">Страна:</p></td>
                    <td width='60%'>
                      {/* <Select
                        size='large'
                        value={registrationAddress.Country.Name ? registrationAddress.Country.Name : undefined}
                        onChange={handleRegistrationAddressChange}
                        showSearch
                        style={{ width: '100%' }}
                        optionFilterProp="children"
                        filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                        filterSort={(optionA, optionB) => optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase())}
                        placeholder="Выберите страну"
                        notFoundContent={<p style={{color: '#000'}}>Данный элемент отсутствует в базе данных! Оставьте заявку на добавление элемента в системе <a href="https://ithd.it/" target='_blank'>ServiceDesk</a></p>}
                        options={selectors.registrationAddressCountries}
                      /> */}
                      <AutoComplete
                        allowClear={true}
                        size='large'
                        options={selectors.registrationAddressCountries}
                        style={{
                            width: '100%',
                        }}
                        value={registrationAddress.Country.Name}
                        filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                        onSelect={(e, option) => handleRegistrationAddressChange(e, option)}
                        onChange={handleRegistrationCountryChange}
                        placeholder="Выберите страну"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td width='40%'><p className="title">Регион:</p></td>
                    <td width='60%'>
                      <AddressSuggestions 
                        ref={regRegionRef}
                        token={DADATA_API_token}
                        filterRestrictValue={true}
                        filterFromBound={'region'}
                        filterToBound={'region'}
                        delay={500}
                        minChars={3}                        
                        filterLocations={{country: registrationAddress.Country.Name ? registrationAddress.Country.Name : '*'}}
                        onChange={(value) => handleRegistrationRegionChange(value)} 
                        inputProps={{
                          onInput: handleRegistrationRegionInput
                        }}              
                      />
                    </td>
                  </tr>      
                  {/* <tr>
                    <td width='40%'><p className="title">Район:</p></td>
                    <td width='60%'>
                      <AddressSuggestions 
                        token={DADATA_API_token}
                        filterRestrictValue={true}
                        filterFromBound={'area'}
                        filterToBound={'area'}
                        delay={500}
                        minChars={3}
                        filterLocations={
                          { 
                            country: registrationAddress.Country.Name,
                            region: regAddressRegion.value
                          }
                        }
                        onChange={(value) => handleRegistrationAreaChange(value)} 
                        inputProps={{
                          onInput: handleRegistrationAreaInput
                        }}                       
                      />
                    </td>
                  </tr>       */}
                  <tr>
                    <td width='40%'><p className="title">Город, населенный пункт:</p></td>
                    <td width='60%'>
                      <AddressSuggestions 
                        ref={regCityRef}
                        token={DADATA_API_token}
                        filterRestrictValue={true}
                        filterFromBound={'city'}
                        filterToBound={'settlement'}
                        delay={500}
                        minChars={3}
                        filterLocations={
                          {
                            country: registrationAddress.Country.Name,
                            region_fias_id: regAddressRegion.fias_id
                          }
                        }
                        onChange={(value) => handleRegistrationCityChange(value)}
                        inputProps={{
                          onInput: handleRegistrationCityInput
                        }}
                      />
                    </td>
                  </tr>      
                  <tr>
                    <td width='40%'><p className="title">Улица:</p></td>
                    <td width='60%'>
                      <AddressSuggestions 
                        ref={regStreetRef}
                        token={DADATA_API_token}
                        filterRestrictValue={true}
                        filterFromBound={'street'}
                        filterToBound={'street'}
                        delay={500}
                        minChars={3}
                        filterLocations={
                          {
                            country: registrationAddress.Country.Name,
                            city_fias_id: regAddressCity.city_fias_id,
                            settlement_fias_id: regAddressCity.settlement_fias_id
                          }
                        }
                        onChange={(value) => handleRegistrationStreetChange(value)}
                        inputProps={{
                          onInput: handleRegistrationStreetInput
                        }}
                      />
                    </td>
                  </tr>      
                  <tr>
                    <td width='40%'><p className="title">Дом:</p></td>
                    <td width='60%'>
                      <input
                        type="text"
                        style={{width: "100%"}}
                        value={regAddressHouse}
                        onChange={handleRegistrationHouseChange}
                      />
                    </td>
                  </tr>      
                  <tr>
                    <td width='40%'><p className="title">Квартира:</p></td>
                    <td width='60%'>
                      <input
                        type="text"
                        style={{width: "100%"}}
                        value={regAddressFlat}
                        onChange={handleRegistrationFlatChange}
                      />
                    </td>
                  </tr>       
                </tbody>
              </table>
              <p>{registrationAddress.ViewAddresses}</p>
              <div style={{ marginTop: "32px" }}></div>
              <button className='btn' style={{ position: "absolute", bottom: "8px", right: "16px" }} onClick={() => setShowRegistrationAddressModal(false)} >ОК</button>
            </div>
            </>
      )}
      {showResidentialAddressModal && (
        <>
          <div className="modal-bg"></div>
          <div className="modal">
            <h4 style={{ textAlign: "center", margin: "5px 0 15px" }}>Место жительства</h4><button className='btn' style={{ position: "absolute", top: "8px", right: "16px" }} onClick={() => setShowResidentialAddressModal(false)} ><CloseOutlined /></button>
            <table>
              <tbody>
                <tr>
                  <td width='40%'><p className="title">Страна:</p></td>
                  <td width='60%'>
                    {/* <Select
                      size='large'
                      value={residentialAddress.Country.Name ? residentialAddress.Country.Name : undefined}
                      onChange={handleResidentialAddressChange}
                      showSearch
                      style={{ width: '100%' }}
                      optionFilterProp="children"
                      filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                      filterSort={(optionA, optionB) => optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase())}
                      placeholder="Выберите страну"
                      notFoundContent={<p style={{color: '#000'}}>Данный элемент отсутствует в базе данных! Оставьте заявку на добавление элемента в системе <a href="https://ithd.it/" target='_blank'>ServiceDesk</a></p>}
                      options={selectors.residentialAddressCountries}
                    /> */}
                    <AutoComplete
                      allowClear={true}
                      size='large'
                      options={selectors.residentialAddressCountries}
                      style={{
                          width: '100%',
                      }}
                      value={residentialAddress.Country.Name}
                      filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase())}
                      onSelect={(e, option) => handleResidentialAddressChange(e, option)}
                      onChange={handleResidentialCountryChange}
                      placeholder="Выберите страну"
                    />
                  </td>
                </tr>
                <tr>
                  <td width='40%'><p className="title">Регион:</p></td>
                  <td width='60%'>
                    <AddressSuggestions 
                      ref={resRegionRef}
                      token={DADATA_API_token}
                      filterRestrictValue={true}
                      filterFromBound={'region'}
                      filterToBound={'region'}
                      delay={500}
                      minChars={3}
                      filterLocations={{country: residentialAddress.Country.Name ? residentialAddress.Country.Name : '*'}}
                      onChange={(value) => handleResidentialRegionChange(value)} 
                      inputProps={{
                        onInput: handleResidentialRegionInput
                      }}                     
                    />
                  </td>
                </tr>      
                {/* <tr>
                  <td width='40%'><p className="title">Район:</p></td>
                  <td width='60%'>
                    <AddressSuggestions 
                      token={DADATA_API_token}
                      filterRestrictValue={true}
                      filterFromBound={'area'}
                      filterToBound={'area'}
                      delay={500}
                      minChars={3}
                      filterLocations={
                        { 
                          country: residentialAddress.Country.Name,
                          region: resAddressRegion.value
                        }
                      }
                      onChange={(value) => handleResidentialAreaChange(value)} 
                      inputProps={{
                        onInput: handleResidentialAreaInput
                      }}                       
                    />
                  </td>
                </tr>       */}
                <tr>
                  <td width='40%'><p className="title">Город, населенный пункт:</p></td>
                  <td width='60%'>
                    <AddressSuggestions 
                      ref={resCityRef}
                      token={DADATA_API_token}
                      filterRestrictValue={true}
                      filterFromBound={'city'}
                      filterToBound={'settlement'}
                      delay={500}
                      minChars={3}
                      filterLocations={
                        {
                          country: residentialAddress.Country.Name,
                          region_fias_id: resAddressRegion.fias_id
                        }
                      }
                      onChange={(value) => handleResidentialCityChange(value)}
                      inputProps={{
                        onInput: handleResidentialCityInput
                      }}
                    />
                  </td>
                </tr>      
                <tr>
                  <td width='40%'><p className="title">Улица:</p></td>
                  <td width='60%'>
                    <AddressSuggestions 
                      ref={resStreetRef}
                      token={DADATA_API_token}
                      filterRestrictValue={true}
                      filterFromBound={'street'}
                      filterToBound={'street'}
                      delay={500}
                      minChars={3}
                      filterLocations={
                        {
                          country: residentialAddress.Country.Name,
                          city_fias_id: resAddressCity.city_fias_id,
                          settlement_fias_id: resAddressCity.settlement_fias_id
                        }
                      }
                      onChange={(value) => handleResidentialStreetChange(value)}
                      inputProps={{
                        onInput: handleResidentialStreetInput
                      }}
                    />
                  </td>
                </tr>      
                <tr>
                  <td width='40%'><p className="title">Дом:</p></td>
                  <td width='60%'>
                    <input
                      type="text"
                      style={{width: "100%"}}
                      value={resAddressHouse}
                      onChange={handleResidentialHouseChange}
                    />
                  </td>
                </tr>      
                <tr>
                  <td width='40%'><p className="title">Квартира:</p></td>
                  <td width='60%'>
                    <input
                      type="text"
                      style={{width: "100%"}}
                      value={resAddressFlat}
                      onChange={handleResidentialFlatChange}
                    />
                  </td>
                </tr>       
              </tbody>
            </table>
            <p>{residentialAddress.ViewAddresses}</p>
            <div style={{ marginTop: "32px" }}></div>
            <button className='btn' style={{ position: "absolute", bottom: "8px", right: "16px" }} onClick={() => setShowResidentialAddressModal(false)} >ОК</button>
          </div>
          </>
      )}
      {showPhotoCropperModal && (
        <>
        <div className="modal-bg" onClick={handleClosePhotoCropperModal}></div>
        <div className="modal" style={{ maxHeight: '80vh' }}>
          <h4 style={{ textAlign: "center", margin: "5px 0 15px" }}>Загрузка фото</h4><button type="button" className='btn' style={{ position: "absolute", top: "8px", right: "16px" }} onClick={handleClosePhotoCropperModal} ><CloseOutlined /></button>
          <input id='cropperUpload' hidden type="file" accept="image/*" onChange={handleImageUpload} />
          {image === null ? 
            (<label htmlFor='cropperUpload'>
              <div className='cropperUploadPanel'><h1>Нажмите для загрузки фото</h1></div>
            </label>) : 
            (<>
              <CustomCropper ref={cropperRef} src={image} />
              <div style={{ display: 'flex', flexWrap: 'wrap', margin: '5px 0 48px' }}>
                <Button shape="circle" onClick={() => cropperRef.current.rotateImage(-90)} icon={<RotateLeftOutlined />} style={{ marginRight: '10px' }} />
                <Button shape="circle" onClick={() => cropperRef.current.rotateImage(90)} icon={<RotateRightOutlined />} style={{ marginRight: '10px' }} />
                <Button shape="circle" onClick={() => cropperRef.current.flipImage(false, true)} icon={<VerticalAlignMiddleOutlined />} style={{ marginRight: '10px' }} />
                <Button shape="circle" onClick={() => cropperRef.current.flipImage(true, false)} icon={<VerticalAlignMiddleOutlined style={{transform: 'rotate(90deg)'}} />} style={{ marginRight: '10px' }} />
              </div>
            </>)
          }          
          
          <Button className='btn' type='secondary' style={{ position: "absolute", bottom: "8px", right: "16px", border: '1px solid #999' }} onClick={(handleCropImage)} >Подтвердить</Button>
        </div>
        </>
      )}
      {formData.AllowedEdit && (<div className='uploadContainer' style={{ marginBottom: '30px' }}>
        <h3>Вложения:</h3>
        <Tooltip placement="right" title='Допустимые расширения файлов к загрузке: "DOC", "DOCX", "XLS", "XLSX", "XLSM", "PPT", "PPTX", "PDF", "TXT", "JPG", "JPEG", "BMP", "PNG". Максимально допустимый размер одного файла: 10 Мб. Максимально допустимое количество файлов: 10' overlayStyle={{ fontSize: '12px', lineHeight: '19px' }}>
          <Dragger {...props} maxCount={10}>
            <CloudUploadOutlined style={{ fontSize: '50px' }} /><br/>
            <p >Нажмите или перетащите файл в эту область, чтобы загрузить</p>
          </Dragger>
        </Tooltip>
      </div>)}
    </div>
  );
};

// Функция для чтения содержимого файла
const readFileAsync = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.onerror = reject;
    reader.readAsBinaryString(file);
  });
};


export default PersonalInfo;
